import React, { useState, useEffect } from "react";
import { Box, Grid2, Typography , Paper,InputBase,Button, buttonBaseClasses} from "@mui/material";
import CloseButton from "../../../ui-utils/latestPics/close button.svg";
import SticktStyles from "./StickyBar.module.css"
import { backendHosts } from "../../../ui-utils/apiConfig"
import validator from "validator";


const StickyMob = () => {
    const [showBar, setShowBar] = useState(false);
    const [isClosed, setIsClosed] = useState(false); 

    const [mobileNo, setMobileNo] = useState("");
    const clientErr = {};
    const [mobClientErr, setMobileClientErr] = useState({});

    const handleMobilenoEnter = () => {
        const formData = { mobileNo };
        console.log(formData);
        const runValidation = () => {
            if (mobileNo.trim().length == 0) {
                clientErr.mobileNo = "Please Enter your mobile number";
                return;
            }
            if (!validator.isMobilePhone(mobileNo, "en-IN")) {
                console.log("false")
                clientErr.mobileNo = "Please Enter Valid mobile number";
                return;
            }
        };
        runValidation();
        if (Object.keys(clientErr).length == 0) {

            const fullUrl = `${backendHosts.REG}/?mobilenofromhome=${mobileNo}&t=${Date.now()}`;
            window.location.href = fullUrl;
            setMobileClientErr({});

        } else {
            setMobileClientErr(clientErr);
        }
    };

    const handleMobileNoChange = (e) => {
        const inputValue = e.target.value;
        const numericValue = inputValue.replace(/\D/g, "");
        const limitedValue = numericValue.slice(0, 10);

        setMobileNo(limitedValue);
      };


    const handleScroll = () => {
        const scrollPosition = window.scrollY;
        const viewportHeight = window.innerHeight;

        if (!isClosed && scrollPosition > viewportHeight) {
            setShowBar(true);
        } else {
            setShowBar(false);
        }
    };

    useEffect(() => {

        window.addEventListener("scroll", handleScroll);


        return () => window.removeEventListener("scroll", handleScroll);
    }, [isClosed]);

    return (
        <>
            {/* <Box style={{ display: "flex", flexDirection: "column" }}>
                {showBar && (
                    <>
                        <Grid2
                            className={SticktStyles.mainCard}
                        >
                            <Grid2 className={SticktStyles.innerBox} >

                                <Box>
                                    <Typography className={SticktStyles.content1}>
                                        Hey, Why Not Start Investing Today?
                                    </Typography>
                                    <Typography className={SticktStyles.content2}>
                                        Open Free Demat Account In 5 Mins
                                    </Typography>
                                </Box>

                                <Paper component="form" className={SticktStyles.mobilefield}>
                                    <Typography className={SticktStyles.preMobile}>91</Typography>
                                    <InputBase
                                        className={SticktStyles.inputbase}
                                        placeholder="Enter your mobile number"
                                        value={mobileNo}
                                        onChange={handleMobileNoChange}
                                    />
                                    <Button className={SticktStyles.dematButton} onClick={handleMobilenoEnter}>
                                        Open a Free Demat Account
                                    </Button>
                                </Paper>
                            </Grid2>


                            <Box
                                className={SticktStyles.buttonCard}
                            >
                                <img
                                    className={SticktStyles.closeButton}
                                    src={CloseButton}
                                    alt="Close Button"
                                    onClick={() => {
                                        setShowBar(false); // Hide the bar immediately
                                        setIsClosed(true); // Permanently close the bar
                                    }}
                                />
                            </Box>
                        </Grid2>
                    </>
                )}
            </Box> */}
        </>


    );
};

export default StickyMob;
